import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Paint({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 17 16' {...props}>
      <Path
        d='M4.53667 10.9851L1.54307 8.13402C0.881475 7.50389 0.881475 6.48294 1.54307 5.85284L6.05027
        1.56027L11.4391 6.69246L6.93187 10.9851C6.27027 11.6144 5.19747 11.6144 4.53667 10.9851Z'
        fillRule='evenodd'
        clipRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={color}
        fill={fill}
      />
      <Path
        d='M13.8342 8.97021C13.8342 8.97021 12.1406 10.7203 12.1406 11.7931C12.1406 12.6799 12.903 13.406
        13.8342 13.406C14.7654 13.406 15.5278 12.6799 15.5278 11.7923C15.5278 10.7203 13.8342 8.97021 13.8342
        8.97021Z'
        fillRule='evenodd'
        clipRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={color}
        fill={fill}
      />
      <Path
        d='M6.04388 1.56147L5.17188 0.715759'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={color}
        fill={fill}
      />
      <Path
        d='M11.4383 6.689H1.07031'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={color}
        fill={fill}
      />
      <Path
        d='M1.46094 14.811H8.32494'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={color}
        fill={fill}
      />
    </IconBase>
  )
}

Paint.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Paint
